import React, { useEffect, useRef, useState } from 'react';
import { POSES } from '../lib/briefyPoses';

export const BriefyCharacter = ({ pose = 'base', height = 80, blink = false, flip = false, className = '', style = {} }) => {
  const [curr, setCurr] = useState(pose);
  const [prev, setPrev] = useState(null);
  const [blinking, setBlinking] = useState(false);
  const fadeTimer = useRef(null);

  useEffect(() => {
    setCurr((c) => {
      if (pose === c) return c;
      setPrev(c);
      if (fadeTimer.current) clearTimeout(fadeTimer.current);
      fadeTimer.current = setTimeout(() => setPrev(null), 500);
      return pose;
    });
  }, [pose]);

  useEffect(() => () => { if (fadeTimer.current) clearTimeout(fadeTimer.current); }, []);

  useEffect(() => {
    if (!blink || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return undefined;
    let alive = true;
    let t1;
    let t2;
    const loop = () => {
      t1 = setTimeout(() => {
        if (!alive) return;
        setBlinking(true);
        t2 = setTimeout(() => { if (!alive) return; setBlinking(false); loop(); }, 170);
      }, 2800 + Math.random() * 3800);
    };
    loop();
    return () => { alive = false; clearTimeout(t1); clearTimeout(t2); };
  }, [blink]);

  const h = typeof height === 'number' ? `${height}px` : height;
  const blinkPose = { peek: 'peek_blink', base: 'blink', sitting: 'sitting_blink' }[curr];
  const src = blinking && blinkPose ? POSES[blinkPose] : (POSES[curr] || POSES.base);
  const imgStyle = flip ? { transform: 'scaleX(-1)' } : undefined;

  return (
    <div className={`relative ${className}`} style={{ height: h, aspectRatio: '2 / 3', ...style }}>
      {prev && (
        <img
          src={POSES[prev] || POSES.base}
          alt=""
          aria-hidden="true"
          draggable="false"
          className="absolute inset-0 w-full h-full object-contain object-bottom select-none"
          style={imgStyle}
        />
      )}
      <img
        key={curr}
        src={src}
        alt="Briefy"
        draggable="false"
        className="absolute inset-0 w-full h-full object-contain object-bottom select-none briefy-pose-fade"
        style={imgStyle}
      />
    </div>
  );
};

export default BriefyCharacter;
